<div *ngIf="user" class="grid-container">
  <div class="filter-buttons-container">
    <button
      mat-icon-button
      class="button-position"
      [disabled]="!groupsGrid?.canClearFilters()"
      (click)="groupsGrid?.clearFilters()"
      [matTooltip]="'common.clear-grid-filter' | translate | lowercase"
    >
      <mat-icon class="material-icons-outlined" svgIcon="reset-grid"></mat-icon>
    </button>

    <button
      mat-icon-button
      *hasPerm="['WLMAdministrationCrud', 'u']"
      [matTooltip]="T_SCOPE + '.add' | translate | lowercase"
      onclick="this.blur()"
      (click)="addGroupsToUser()"
    >
      <mat-icon>add</mat-icon>
    </button>
    <button
      mat-icon-button
      *hasPerm="['WLMAdministrationCrud', 'u']"
      [matTooltip]="T_SCOPE + '.remove' | translate | lowercase"
      [disabled]="!selectedGroups?.length"
      (click)="removeGroup()"
    >
      <mat-icon svgIcon="delete"></mat-icon>
    </button>
  </div>
  <wlm-generic-grid
    class="wtr-fx-flex-grow"
    [additionalFilters]="additionalFilters"
    [gridSettings]="gridSettings"
    [gridFiltersForBinding]="gridFilters"
    [(selectedItems)]="selectedGroups"
    [removeSelection$]="removeSelection$"
    (selectedItemChanged)="getSelectedGroup($event)"
    [subscriptionTag]="usersGroupGridName"
    [showSelectedList]="true"
    [showSelectedItems]="false"
  ></wlm-generic-grid>
</div>
